import fetch from 'utils/request';
import { deepCopy, isArray, formatDate } from 'utils/index';
import { sift_query_list } from 'utils/sift';
const ls = process.env.NODE_ENV === 'development' ? '/larkswitch' : '';
// const ls = '';

// ! 沟通列表查询
export function apiPostCommunicateList(data){
	data = deepCopy(data);
	if(data.date) {
		data.createdAfter = formatDate(data.date[0], 'YYYY-MM-DD HH:mm:ss');
		data.createdBefore = formatDate(data.date[1], 'YYYY-MM-DD HH:mm:ss');
	}
	delete data.phone;
    return fetch({
        url: '/ia/incident/queryIncidentPage.json',
        method: 'post',
        data: data,
		contentType: 'formData'
    });
}

// ! 沟通字段
export function apiQueryCommunicateColumn(data) {
	return fetch({
		url: '/ia/tableColumn/queryList.json',
		method: 'post',
		data: sift_query_list(data),
		contentType: 'formData'
	});
}

// ! 新增沟通信息
export function apiPostCreateCommunicate(data) {
	data = deepCopy(data);
	const idArr = ['busiTypeOne', 'busiTypeTwo', 'busiTypeThree', 'busiTypeFour', 'busiTypeFive', 'busiTypeSix', 'busiTypeSeven', 'busiTypeEight', 'busiTypeNine', 'busiTypeTen'];
	const nameArr = ['busiTypeOneName', 'busiTypeTwoName', 'busiTypeThreeName', 'busiTypeFourName', 'busiTypeFiveName', 'busiTypeSixName', 'busiTypeSevenName', 'busiTypeEightName', 'busiTypeNineName', 'busiTypeTenName'];
	if(data.busi_type) {
		for(const [index, value] of data.busi_type.entries()) {
			data[idArr[index]] = value;
		}
	}
	if(data.busi_type_name) {
		for(const [index, value] of data.busi_type_name.entries()) {
			data[nameArr[index]] = value;
		}
	}
	Object.keys(data).forEach(i => {
		if(isArray(data[i])) {
			data[i] = data[i].toString();
		}
	});
	delete data.customData;
	delete data.dataList;
	delete data.updated;
	return fetch({
		url: '/ia/incident/addIncident.json',
		method: 'post',
		data: sift_query_list(data),
		contentType: 'formData'
	});
}

// ! 更新沟通信息
export function apiPostUpdateCommunicate(data) {
	data = deepCopy(data);
	const idArr = ['busiTypeOne', 'busiTypeTwo', 'busiTypeThree', 'busiTypeFour', 'busiTypeFive', 'busiTypeSix', 'busiTypeSeven', 'busiTypeEight', 'busiTypeNine', 'busiTypeTen'];
	const nameArr = ['busiTypeOneName', 'busiTypeTwoName', 'busiTypeThreeName', 'busiTypeFourName', 'busiTypeFiveName', 'busiTypeSixName', 'busiTypeSevenName', 'busiTypeEightName', 'busiTypeNineName', 'busiTypeTenName'];
	if(data.busi_type) {
		for(const [index, value] of data.busi_type.entries()) {
			data[idArr[index]] = value;
		}
	}
	if(data.busi_type_name) {
		if(typeof data.busi_type_name == 'string') {
			data.busi_type_name = data.busi_type_name.split(',');
		}
		for(const [index, value] of data.busi_type_name.entries()) {
			data[nameArr[index]] = value;
		}
	}
	Object.keys(data).forEach(i => {
		if(isArray(data[i])) {
			data[i] = data[i].toString();
		}
	});
	delete data.customData;
	delete data.dataList;
	delete data.updated;
	return fetch({
		url: '/ia/incident/updIncidentOrder.json',
		method: 'post',
		data: sift_query_list(data),
		contentType: 'formData'
	});
}

// ! 根据录音ID 获取 录音文件
export function apiPostLarksWitchLocation(data) {
	return fetch({
		// url: '/larkswitch/project/manage/queryRecordLocation.json',
		url: `${ls}/project/manage/queryRecordLocation.json`,
		method: 'post',
		data: data,
		contentType: 'formData',
		baseUrlType: 'larkSwitch'
	});
}
